import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const randomWrappers = document.querySelectorAll('.js-random-wrap');
if (randomWrappers) {
  randomWrappers.forEach(wrapper => {

    const randomElms = wrapper.querySelectorAll('.js-random-number');
    randomElms.forEach(element => {

      let randomTl = gsap.timeline({
        scrollTrigger: {
          scrub: 1,
          trigger: wrapper,
          start: 'top bottom-=8%',
          end: () => '+=' + (wrapper.clientHeight - wrapper.clientHeight),
          // markers: true
        }
      })

      const radix = 10;
      const digits = element.innerText.length;
      const finalNumber = element.innerText;
      const totalCycles = 30; // total number of times the number will change
      const cycleDuration = .5; // duration for each cycle in seconds
      let randomValue = 0;

      if (digits == 1) {
        randomValue = 10;
      } else if (digits == 2) {
        randomValue = 100;
      } else {
        randomValue = 10000;
      }

      randomTl.addLabel('start')
        .to(element, {
          duration: .02,
          ease: 'linear',
          repeat: totalCycles - 1,
          onRepeat: () => {
            const randomNumber = Math.floor(Math.random() * randomValue);
            element.innerText = randomNumber.toLocaleString(); // 3桁カンマ区切り
          },
          onComplete: () => {
            element.innerText = finalNumber; // Set to the final number
          }
        })
    })
  })
}